// extracted by mini-css-extract-plugin
export default {"triangle":"m44C5","outer":"R6MDZ","inner":"Yc2FE","right":"ri4cM","left":"asQz0"};